import { Box, CircularProgress, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type AuthLoadingScreenProps = {
  message?: string;
  overlay?: boolean;
  showSpinner?: boolean;
  children?: ReactNode;
  testId?: string;
};

const authLoadingBackground =
  'linear-gradient(-6deg, rgba(80, 90, 84, 0.8) 28%, rgba(189, 204, 190, 0.7) 100%), #000000';

export default function AuthLoadingScreen({
  message = 'Signing in...',
  overlay = false,
  showSpinner = true,
  children,
  testId,
}: AuthLoadingScreenProps) {
  return (
    <Box
      data-overlay={overlay ? 'true' : 'false'}
      data-testid={testId}
      sx={{
        alignItems: 'center',
        background: authLoadingBackground,
        display: 'flex',
        inset: overlay ? 0 : 'auto',
        justifyContent: 'center',
        minHeight: '100vh',
        px: 3,
        py: 6,
        position: overlay ? 'fixed' : 'relative',
        width: '100%',
        zIndex: overlay ? 9999 : 'auto',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          maxWidth: 420,
          textAlign: 'center',
        }}
      >
        {children ?? (
          <>
            {showSpinner ? <CircularProgress size={40} sx={{ color: '#EDF2F0' }} /> : null}
            <Typography
              sx={{
                color: '#EDF2F0',
                fontFamily: "'Basis Grotesque', sans-serif",
                fontSize: '18px',
                fontWeight: 500,
                letterSpacing: '0.15px',
                lineHeight: 1.6,
              }}
            >
              {message}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
}
